import ApiService from '../apiservice'

export default class DashboardService extends ApiService {

    constructor() {
        super('')
    }

    getDashboardInformation(plate, pageSize, pageIndex) {
        return this.get('/plates/status', {
            "plateName": plate,
            "pageSize": pageSize,
            "pageIndex": pageIndex
        }, 1);
    }

    getDashboardOutputs(plate, pageSize, pageIndex) {
        return this.get('/plates/status/horimeter', {
            "plateName": plate,
            "pageSize": pageSize,
            "pageIndex": pageIndex
        }, 1);
    }
}